var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0393 12.75C14.8397 12.75 16.2991 11.4069 16.2991 9.75C16.2991 8.09315 14.8397 6.75 13.0393 6.75C11.239 6.75 9.77948 8.09315 9.77948 9.75C9.77948 11.4069 11.239 12.75 13.0393 12.75Z",
    stroke: "#B27D52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1888 9.75C21.1888 16.5 13.0393 21.75 13.0393 21.75C13.0393 21.75 4.88971 16.5 4.88971 9.75C4.88971 7.76088 5.74832 5.85322 7.27666 4.4467C8.805 3.04018 10.8779 2.25 13.0393 2.25C15.2007 2.25 17.2735 3.04018 18.8019 4.4467C20.3302 5.85322 21.1888 7.76088 21.1888 9.75V9.75Z",
    stroke: "#B27D52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/MapPin.6122e1c008909c6b77f519234e568365.svg";
export { ForwardRef as ReactComponent };